import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";

import axios from "axios";

function SignMatch() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    sign_label: "",
    remark: "",
    status: ""
  });
  const [values, setValues] = useState({ image1: "", image2: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log(cardData);
  }, [cardData]);

  const onChange = (e) => {
    const { name, value } = e.target;
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      // console.log("base64String", base64String);

      const formField = {
        ...values,

        [name]: base64String
      };
      setValues(formField);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    if(!values.image1 || !values.image2){
      alert("Please select both the images");
      setLoading(true);
      return;
    }

    setCardData({
      Document_type: "",
      face_match: "",
      confidence_score: "",
      face_count: ""
    });
    // var data = new FormData();
    // data.append('base64_image1', values.base64_image1)
    // data.append('base64_image2', values.base64_image2)
    // var config = {
    //   method: "post",
    //   url:
    //     "https://t1wltha8w2.execute-api.ap-south-1.amazonaws.com/default/Signature_match_ainxt",
    //   headers: {
    //     "x-api-key": "QIlzEU9wVr2bsuiQDCr3Z9pvpo3OvlYT68xqh4kL",
    //     authorizationToken: "w3XYo7Q21ohvbUFE"
    //   },
    //   data: values
    // };

    // var config = {
    //   method: "post",
    //   url:
    //     "https://c882ir648g.execute-api.ap-south-1.amazonaws.com/default/new_signature_matching?requestid=ujhi7845&threshold=60",
    //   headers: {
    //     "x-api-key": "ReONEPuk5s1uSgbwJVtnG6kybZNUnSAC2Em1QMMg",
    //     authorizationToken: "ot[WW#lLAv4<CoNw"
    //   },
    //   data: values
    // };

    var config = {
      method: "post",
      url:
        "https://6q1hga22x0.execute-api.ap-south-1.amazonaws.com/default/abrathi-signatureMatching-uat-API?requestId=63eq98uhde794w80hf",
      headers: {
        "x-api-key": "B7JsIp8FUM3BNYtEa14KV6LGIahiKwCXa15C7owa",
        authorizationToken: "yXSsEXdbLDTCWmpI"
      },
      data: values
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true);
      })
      .catch(function (error) {
        setLoading(true);
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => { }, [cardData]);

  return (
    <div>
      <div>
        <div>
          <div class="container containerBoreder " id="pan">
            <h2 class="pageTitle">Sign Match</h2>
            <div class="row">
              <div class="col-4">
                <input type="file" name="image1" onChange={onChange} />
              </div>
              <div class="col-4">
                <input type="file" name="image2" onChange={onChange} />
              </div>
              {loading ? (
                <div class="col-4">
                  <button class="btn btn-primary" onClick={submit}>
                    Submit
                  </button>
                </div>
              ) : (
                <ReactBootStrap.Spinner animation="border" />
              )}
            </div>
            <br />
            <table style={{ display: "flex" }} class="table">
              <tbody>
                <tr>
                  <td>
                    {values.image1 ? (
                      <img
                        style={{
                          backgroundColor: "#44014C",
                          width: "300px",
                          minHeight: "200px"
                        }}
                        alt=""
                        className="image"
                        src={"data:image/png;base64," + values.image1}
                      ></img>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>
                    {values.image2 ? (
                      <img
                        style={{
                          backgroundColor: "#44014C",
                          width: "300px",
                          minHeight: "200px"
                        }}
                        alt=""
                        src={"data:image/png;base64," + values.image2}
                      ></img>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Is Match</th>
                  <td>{cardData.status}</td>
                </tr>
                <tr>
                  <th>Confidence Scrore</th>
                  <td>{cardData.score}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignMatch;
